<template>
  <div class="setting-content--section">
        <TitleBar v-if="$route.path.includes('control-panel')">
            <template v-slot:title>
              <span v-translate>Cost Types</span>
            </template>
            <template v-slot:buttons>
                <GekkoButton 
                    :text="$gettext('Copy from ledger')" 
                    @click="copyFromLedger"
                    icon="fa-solid fa-clone"
                    class="mr-2"
                    />
            </template>
        </TitleBar>
        <div class="content" style="display: flex; flex-direction: column;">
            <h4 v-translate>Your custom categories</h4>
            <div class="help-block" v-show="showHint">
                <p v-translate>
                    These cost types will be seen by all your customers and they will be able to book their receipts on these entries.
                    If you want to hide cost types, archive them. If you want to manage cost types per customer,
                    you have to go to your customers local account.
                </p>
            </div>
            <div class="setting-content--section mb-4">
                <CostTypeTable flag="custom" @costTypeCreated="onCostTypeCreated" @costTypeUpdated="onCostTypeUpdated" ref="cost-type-table-custom" />
            </div>
            <h4 class="mb-2" v-translate>Default categories</h4>
            <div class="setting-content--section">
                <CostTypeTable flag="default" ref="cost-type-table-default" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import UserService from "@/store/services/user.service.js";
import ProfileService from "@/store/services/profile.service.js";
import CostTypeTable from "@/components/cost_types/CostTypeTable.vue";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import CostTypeService from "@/store/services/costtype.service";
// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "CostTypesSettings",
    components: {CostTypeTable, TitleBar, GekkoButton},
    mixins: [settingsPageSetup],
    data() {
        return {
            showHint: false,
            pageSettings: {
                title: this.$gettext("Company cost categories"),
                showCompanyPicker: true
            },
            form: {
                profile: {}
            },
            user: {},
            showDismissibleAlert: false,
        }
    },
    computed: {
        ...mapGetters ({ 
            currentUser: 'main/getCurrentUser',
            getCompanyId: 'main/getCompanyId'
        }),        
    },
    created(){
        // TODO REFACTOR retrieveCurrent
        
        UserService.retrieveCurrent({ extended: 'True' }).then((response) => {
            this.user = response.data;
        });

        ProfileService.list({ user: this.currentUser.id }).then((response) => {
            this.form.profile = response.data[0];
        })
    },
    methods: {
        onSubmit(evt) {
            var vm = this;
            evt.preventDefault();
            delete this.form.profile.avatar;
            delete this.form.profile.avatar_thumb;
            ProfileService.update(this.form.profile.id, this.form.profile).then(function(){
                vm.showDismissibleAlert = true;
            })
        },
        onCostTypeCreated(val) {
            this.$emit("costTypeCreated", val);
        },
        onCostTypeUpdated(val) {
            this.$emit("costTypeUpdated", val);
        },
        copyFromLedger() {
            const ConfirmModalConstructor = this.$options.components['confirm-modal']
            const confirmModalInstance = new ConfirmModalConstructor({ propsData: {
                title: this.$gettext('Update cost types'),
                message: this.$gettext('If you copy the cost types from your ledger, all existing cost types of the customer will be overwritten. Do you want to continue?'),
                options: {
                    variant: 'primary',
                    confirmText: this.$gettext('Ok')
                }
            }})
            confirmModalInstance.$mount()
            document.body.appendChild(confirmModalInstance.$el)
            confirmModalInstance.$on('confirmed', () => {
                if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                    confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                }
                CostTypeService.copyFromLedger({ customer: this.getCompanyId }).then(() => {
                    this.$refs['cost-type-table-custom'].setupData();
                    this.$refs['cost-type-table-default'].setupData();
                    
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Success"),
                        text: this.$gettext("The cost types have been copied from your ledger to the customer's account."),
                        variant: "success",
                        duration: 4
                    });
                }).catch(() => {
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Error"),
                        text: this.$gettext("There was an error updating the cost type of your customer."),
                        variant: "danger",
                        duration: 4
                    });
                })
            })
            confirmModalInstance.$on('cancel', () => {
                if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                    confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                }
            })
        }
    }
};
</script>
